angular.module('aprima-core-ui').config(function() {
    'use strict';

    $.fn.extend({
        firstOrNull: function() {
            return this && this.length ? this.first() : null;
        }
    });
});